export default __webpack_public_path__ + "static/media/service_6.da23bad3.jpg";